import { createSelector } from 'reselect';
import { QUESTIONS, PRACTICE } from '../constants/assessmentItemType';

export const getIsNWDataFetched = (state) => state.isDataFetched;

export const getNWContent = (state, pageType, questionIndex = 0) => {
    let content;
    switch (pageType) {
    case QUESTIONS:
        content = state.questions;
        break;
    case PRACTICE:
        content = state.practice;
        break;
    default:
        return {};
    }
    return content[questionIndex];
};

export const getNWPossibleResponses = (state, pageType, questionIndex = 0) => {
    const content = getNWContent(state, pageType, questionIndex);
    if (content) {
        return content.possibleResponses;
    }
    return [];
};

export const getNWStimulusAudio = (state, pageType, questionIndex = 0) => {
    const content = getNWContent(state, pageType, questionIndex);
    if (content) {
        return content.stimulus.audio;
    }
    return '';
};

export const getNWTotalQuestions = (state) => {
    if (state.questions) {
        return state.questions.length;
    }
    return 0;
};

export const getNWPracticeCorrectResponseId = createSelector(
    [getNWContent, getNWPossibleResponses],
    (content, possibleResponses) => possibleResponses.findIndex((possibleResponse) => possibleResponse.id === content.correctResponse),
);
